// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"strengthOfSchedule__wrapper--3mU_x","sosTable":"strengthOfSchedule__sosTable--PcV0U"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/StrengthOfSchedule/strengthOfSchedule.css
// module id = /rGX
// module chunks = 38